import '@presentation/components/Modal';

export interface ConfirmActionOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  host?: HTMLElement;
}

type ModalEl = HTMLElement & { open: () => void; close: () => void };

/**
 * Boîte de confirmation accessible, bâtie sur `<nexxus-modal>`.
 * Résout `true` si l'utilisateur confirme, `false` s'il annule ou ferme.
 */
export function confirmAction(opts: ConfirmActionOptions): Promise<boolean> {
  return new Promise((resolve) => {
    const parent = opts.host ?? document.body;
    const modal = document.createElement('nexxus-modal') as ModalEl;
    modal.setAttribute('title', opts.title);
    modal.setAttribute('size', 'sm');
    modal.setAttribute('data-confirm', '');

    const body = document.createElement('p');
    body.style.margin = '0';
    body.style.lineHeight = '1.5';
    body.style.whiteSpace = 'pre-wrap';
    body.textContent = opts.message;

    const footer = document.createElement('div');
    footer.slot = 'footer';
    footer.style.display = 'flex';
    footer.style.gap = '8px';

    const cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.className = 'btn btn-ghost';
    cancel.textContent = opts.cancelLabel ?? 'Annuler';

    const confirm = document.createElement('button');
    confirm.type = 'button';
    confirm.className = opts.danger ? 'btn btn-danger' : 'btn btn-primary';
    confirm.textContent = opts.confirmLabel ?? 'Confirmer';

    footer.append(cancel, confirm);
    modal.append(body, footer);
    parent.appendChild(modal);

    let settled = false;
    const finish = (ok: boolean): void => {
      if (settled) return;
      settled = true;
      modal.close();
      modal.remove();
      resolve(ok);
    };

    cancel.addEventListener('click', () => finish(false));
    confirm.addEventListener('click', () => finish(true));
    modal.addEventListener('close', () => finish(false));
    modal.open();
  });
}
